import { Navigation, Phone } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { STORES } from "../../data/stores";

export default function StoresSection() {
  return (
    <section id="stores" data-testid="stores-section" className="relative border-t border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Chapter number="05" title="Visit Us" />
          <h2 className="font-display text-4xl uppercase tracking-tight text-white sm:text-5xl">
            5 stores across <span className="text-[#FF3B30]">Bengaluru</span>
          </h2>
          <p className="mt-6 max-w-md text-base text-white/60">
            Claim your reward at the store you picked during registration.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-2 xl:grid-cols-3">
          {STORES.map((store, i) => (
            <Reveal key={store.slug} delay={i * 0.08}>
              <div
                data-testid={`store-card-${store.slug}`}
                className="group flex h-full flex-col bg-[#0a0a0a] p-8 transition-colors duration-300 hover:bg-[#121212]"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-4xl text-white/10 transition-colors duration-300 group-hover:text-[#FF3B30]">
                    0{i + 1}
                  </span>
                  <span className="h-3 w-3 rotate-45 bg-[#FFCC00] opacity-0 transition-opacity duration-300 group-hover:opacity-100" aria-hidden />
                </div>
                <h3 className="mt-6 font-display text-2xl uppercase text-white">{store.name}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/50">{store.address}</p>
                <p className="mt-4 font-heading text-sm font-semibold tracking-wider text-white/70">
                  {store.phone}
                </p>
                <div className="mt-8 flex gap-3">
                  <a
                    href={`tel:${store.tel}`}
                    data-testid={`call-now-button-${store.slug}`}
                    className="flex flex-1 items-center justify-center gap-2 bg-[#FF3B30] px-4 py-3 font-heading text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-white hover:text-[#FF3B30]"
                  >
                    <Phone className="h-4 w-4" aria-hidden /> Call Now
                  </a>
                  <a
                    href={store.maps}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`directions-button-${store.slug}`}
                    className="flex flex-1 items-center justify-center gap-2 border border-white/20 px-4 py-3 font-heading text-xs font-bold uppercase tracking-[0.15em] text-white/80 transition-colors duration-300 hover:border-[#FFCC00] hover:text-[#FFCC00]"
                  >
                    <Navigation className="h-4 w-4" aria-hidden /> Directions
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.4}>
            <div className="flex h-full flex-col justify-between bg-[#FF3B30] p-8">
              <p className="font-display text-3xl uppercase leading-tight text-white">
                Not sure which store?
              </p>
              <div className="mt-8">
                <p className="text-sm text-white/80">
                  Register for the offer and our team will help you pick the closest Tyre Empire.
                </p>
                <a
                  href="#claim"
                  data-testid="stores-claim-link"
                  className="mt-6 inline-block bg-white px-6 py-3 font-heading text-xs font-bold uppercase tracking-[0.2em] text-[#FF3B30] transition-colors duration-300 hover:bg-black hover:text-white"
                >
                  Register Now
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
